module.exports = __webpack_public_path__ + "img/reUpload.9f930661.svg";